import request from '../request';
let link = process.env.NODE_ENV == 'development' ? '/host' : process.env.API;
// 公司搜索
export const getCompanyList = params => {
  return request({
    url: link + '/static/v1/company_name',
    method: 'get',
    params
  })
}

/*
  @ 模糊搜索 公司，返回十个选项
  * keyword 搜索关键词
*/
export const companies = (payload, callback) => {
  return request({
    url: link + 'hr/v1/options/companies',
    method: 'get',
    Authorization: true,
    params: payload
  })
}
// 屏蔽公司列表
export const blockingCompanies = (payload) => {
  return request({
    url: '/v3/jobs/blocking_companies',
    method: 'get',
    Authorization: true,
    params: payload
  })
}
// 取消疲敝公司
export const closeBlockingCompanies = (company_token) => {
  return request({
    url: `/v3/jobs/blocking_companies/${company_token}`,
    method: 'delete',
    Authorization: true
  })
}
// 添加疲敝公司
export const addBlockingCompanies = (company_token, data) => {
  return request({
    url: `/v3/jobs/blocking_companies/${company_token}`,
    method: 'post',
    Authorization: true,
    data
  })
}

export const companyAutoCompletions = params => {
  return request({
    url: link + `/static/v1/company_auto_completions`,
    method: 'get',
    Authorization: true,
    params
  })
}
// 品牌公司混搜补全接口
export const blockingCompanyAutoCompletions = params => {
  return request({
    url: link + `/static/v1/brand_company_auto_completions`,
    method: 'get',
    Authorization: true,
    params
  })
}
// 详情
export const getComp = (company_token) => {
  return request({
    url: link + `/static/v2/companies/${company_token}?type='hr'`,
    method: 'get',
    Authorization: true
  })
}

// 收藏（关注）公司
export const favoriteCompany = (data) => {
  return request({
    url: `/v3/favorite_companies`,
    method: 'POST',
    data,
    Authorization: true
  })
}

// 取消收藏（关注）公司
export const unFavoriteCompany = (company_token) => {
  return request({
    url: `/v3/favorite_companies/${company_token}`,
    method: 'delete',
    Authorization: true
  })
}

// 是否收藏（关注）公司
export const getFavoriteCompanyState = (company_token) => {
  return request({
    url: `/v3/favorite_companies/${company_token}`,
    method: 'get',
    Authorization: true
  })
}

// 获取随机公司数据（ onboarding 流程）
export const getRandomCompanyList = () => {
  return request({
    url: `/v3/career_path_issues/random_companies`,
    method: 'get',
    Authorization: true
  })
}

// 批量关注公司（ onboarding 流程）
export const batchFollowCompany = (data) => {
  return request({
    url: `/v3/favorite_companies_batch`,
    method: 'POST',
    data,
    Authorization: true
  })
}
